import { Box, Stack } from "@mui/material";
import i18n from "src/i18n";

export const firstTourSteps = (isMobile, isScrollableDrawer) => [
    {
        target: "body",
        title: <Stack justifyContent="center" alignItems="center" >
            <img width={50} style={{ objectFit: "cover" }} src="/static/hand-up.webp" />
            {i18n.t("tutorial.firstTour.title")}
        </Stack>,
        content: i18n.t("tutorial.firstTour.step1"),
        placement: "center",
    },
    {
        target: "#toobar-credit-details",
        content: i18n.t("tutorial.firstTour.step2"),
        placement: "bottom",
    },
    {
        target: "#popper-credit-details",
        content: i18n.t("tutorial.firstTour.step3"),
        placement: "right",
    },
    {
        target: "#charge-amount-cards",
        content: i18n.t("tutorial.firstTour.step4"),
        placement: "top",
    },
    {
        target: "#warehouse-sidebar",
        content: i18n.t("tutorial.firstTour.step5"),
        placement: "top",
        styles: {
            spotlight: {
                marginTop: isScrollableDrawer ? isMobile ? 160 : 167 : 0,
            },
        },

    },
    {
        target: "#warehouse-add-btn",
        content: i18n.t("tutorial.firstTour.step6"),
        placement: "top",
    },
    {
        target: "#mapitShip-btn",
        content: i18n.t("tutorial.firstTour.step7"),
        placement: "left",
        styles: {
            spotlight: {
                marginTop: isScrollableDrawer ? isMobile ? 160 : 167 : 0,
            },
        },

    },
    {
        target: "#price-calculator-btn",
        content: i18n.t("tutorial.firstTour.step8"),
        placement: "bottom",
        styles: {
            spotlight: {
                marginTop: isScrollableDrawer ? isMobile ? 445 : 450 : 0,
            },
        },
    },
    {
        target: "#price-calculator-card",
        content: i18n.t("tutorial.firstTour.step9"),
        placement: "top",
    },
    {
        target: "#view-prices-btn",
        content: i18n.t("tutorial.firstTour.step10"),
        placement: "top",
    },

    {
        target: "#mapitShip-btn",
        content: i18n.t("tutorial.firstTour.step11"),
        placement: "left",
        styles: {
            spotlight: {
                marginTop: isScrollableDrawer ? isMobile ? 160 : 167 : 0,
            },
        },

    },
    {
        target: "#shipment-btn",
        content: i18n.t("tutorial.firstTour.step12"),
        placement: "top",
        styles: {
            spotlight: {
                marginTop: isScrollableDrawer ? isMobile ? 445 : 450 : 0,
            },
        },

    },
    {
        target: "#create-order-btn",
        content: i18n.t("tutorial.firstTour.step13"),
        placement: "top",
    },
    {
        target: ".order-table",
        content: i18n.t("tutorial.firstTour.step14"),
        placement: "top",
    },
    {
        target: "#choses-company-order",
        content: i18n.t("tutorial.firstTour.step15"),
        placement: "top",
    },
    // Download AWB steps (inspired from DownloadAwbTour)
    // Step 15: Status tab for assigned to shipping company
    {
        target: "#simple-tab-1",
        content: i18n.t("tutorial.downloadAwbTour.statusTab"),
        placement: "bottom",
    },
    // Step 16: Data grid row (dynamic - content may change based on data availability)
    {
        target: "#mapit-ship-orders-table",
        content: i18n.t("tutorial.downloadAwbTour.selectRow"),
        placement: "bottom",
        disableBeacon: true,
        disableOverlayClose: true,
        disableCloseOnEsc: true,
        spotlightClicks: false,
        data: {
            isDynamic: true,
            fallbackTarget: "body",
        },
    },
    // Step 17: Download AWB button
    // {
    //     target: "#mapitShip-download-awb-btn",
    //     content: i18n.t("tutorial.downloadAwbTour.downloadAwbBtn"),
    //     placement: "top",
    //     disableBeacon: true,
    //     disableOverlayClose: true,
    //     disableCloseOnEsc: true,
    //     styles: {
    //         spotlight: {
    //             marginTop: isScrollableDrawer ? isMobile ? 0 : 32 : 0,
    //         },
    //     },
    // },
    // Step 18: No data fallback - Shows when no shipments exist
    {
        target: "body",
        title: (
            <Stack justifyContent="center" alignItems="center">
                <img
                    width={isMobile ? 370 : 600}
                    style={{ objectFit: "contain", marginBottom: 16 }}
                    src="/static/download-awb-guide.gif"
                    alt="Download AWB Guide"
                />
            </Stack>
        ),
        content: i18n.t("tutorial.downloadAwbTour.noDataFallback"),
        placement: "center",
        styles: {
            tooltip: {
                maxWidth: isMobile ? 370 : 700,
                width: isMobile ? 370 : 700,
            },
        },
    },
    // Step 19: Completion
    {
        target: "body",
        title: <Box display="flex" justifyContent="center" alignItems="center">
            <img width={50} style={{ objectFit: "cover" }} src="/static/rocket.png" />
        </Box>,
        content: i18n.t("tutorial.firstTour.end"),
        placement: "center",
    },
];
